import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HapticService {
  private isNativePlatform: boolean = false;

  constructor() {
    this.checkPlatform();
  }

  private async checkPlatform() {
    try {
      const { Capacitor } = await import('@capacitor/core');
      this.isNativePlatform = Capacitor.isNativePlatform();
    } catch {
      this.isNativePlatform = false;
    }
  }

  async light() {
    if (!this.isNativePlatform) return;
    try {
      const { Haptics, ImpactStyle } = await import('@capacitor/haptics');
      await Haptics.impact({ style: ImpactStyle.Light });
    } catch (error) {
    }
  }

  async medium() {
    if (!this.isNativePlatform) return;
    try {
      const { Haptics, ImpactStyle } = await import('@capacitor/haptics');
      await Haptics.impact({ style: ImpactStyle.Medium });
    } catch (error) {
    }
  }

  async heavy() {
    if (!this.isNativePlatform) return;
    try {
      const { Haptics, ImpactStyle } = await import('@capacitor/haptics');
      await Haptics.impact({ style: ImpactStyle.Heavy });
    } catch (error) {
    }
  }

  async success() {
    if (!this.isNativePlatform) return;
    try {
      const { Haptics, NotificationType } = await import('@capacitor/haptics');
      await Haptics.notification({ type: NotificationType.Success });
    } catch (error) {
    }
  }

  async warning() {
    if (!this.isNativePlatform) return;
    try {
      const { Haptics, NotificationType } = await import('@capacitor/haptics');
      await Haptics.notification({ type: NotificationType.Warning });
    } catch (error) {
    }
  }

  async error() {
    if (!this.isNativePlatform) return;
    try {
      const { Haptics, NotificationType } = await import('@capacitor/haptics');
      await Haptics.notification({ type: NotificationType.Error });
    } catch (error) {
    }
  }

  async selectionStart() {
    if (!this.isNativePlatform) return;
    try {
      const { Haptics } = await import('@capacitor/haptics');
      await Haptics.selectionStart();
    } catch (error) {
    }
  }

  async selectionChanged() {
    if (!this.isNativePlatform) return;
    try {
      const { Haptics } = await import('@capacitor/haptics');
      await Haptics.selectionChanged();
    } catch (error) {
    }
  }

  async selectionEnd() {
    if (!this.isNativePlatform) return;
    try {
      const { Haptics } = await import('@capacitor/haptics');
      await Haptics.selectionEnd();
    } catch (error) {
    }
  }

  async vibrate(duration: number = 300) {
    if (!this.isNativePlatform) return;
    try {
      const { Haptics } = await import('@capacitor/haptics');
      await Haptics.vibrate({ duration });
    } catch (error) {
    }
  }
}
